export const IINFieldKeyFactory = (passengerID: string): string => `IIN_${passengerID}`;
